import { render, staticRenderFns } from "./OnlineCourse.vue?vue&type=template&id=16ed2c44&scoped=true"
import script from "./OnlineCourse.vue?vue&type=script&lang=js"
export * from "./OnlineCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed2c44",
  null
  
)

export default component.exports